import type { Correction } from '@kimuno/api-sdk';

import type { AsyncAction } from './common.actionTypes';

export enum CREATE_CORRECTION {
	START = 'CREATE_CORRECTION_START',
	SUCCESS = 'CREATE_CORRECTION_SUCCESS',
	ERROR = 'CREATE_CORRECTION_ERROR',
}

export enum GET_CORRECTION {
	START = 'GET_CORRECTION_START',
	SUCCESS = 'GET_CORRECTION_SUCCESS',
	ERROR = 'GET_CORRECTION_ERROR',
}

export enum UPDATE_CORRECTION {
	START = 'UPDATE_CORRECTION_START',
	SUCCESS = 'UPDATE_CORRECTION_SUCCESS',
	ERROR = 'UPDATE_CORRECTION_ERROR',
}

export enum ADD_STUDENT_WORK {
	START = 'ADD_STUDENT_WORK_START',
	SUCCESS = 'ADD_STUDENT_WORK_SUCCESS',
	ERROR = 'ADD_STUDENT_WORK_ERROR',
}

export enum REMOVE_STUDENT_WORK {
	START = 'REMOVE_STUDENT_WORK_START',
	SUCCESS = 'REMOVE_STUDENT_WORK_SUCCESS',
	ERROR = 'REMOVE_STUDENT_WORK_ERROR',
}

export type CreateCorrectionAction = AsyncAction<
	CREATE_CORRECTION.START,
	CREATE_CORRECTION.SUCCESS,
	CREATE_CORRECTION.ERROR,
	Correction
>;

export type GetCorrectionAction = AsyncAction<
	GET_CORRECTION.START,
	GET_CORRECTION.SUCCESS,
	GET_CORRECTION.ERROR,
	Correction,
	{ correctionId: string }
>;

export type UpdateCorrectionAction = AsyncAction<
	UPDATE_CORRECTION.START,
	UPDATE_CORRECTION.SUCCESS,
	UPDATE_CORRECTION.ERROR,
	Correction,
	{ correctionId: string }
>;

export type AddStudentWorkAction = AsyncAction<
	ADD_STUDENT_WORK.START,
	ADD_STUDENT_WORK.SUCCESS,
	ADD_STUDENT_WORK.ERROR,
	Correction,
	{ correctionId: string }
>;

export type RemoveStudentWorkAction = AsyncAction<
	REMOVE_STUDENT_WORK.START,
	REMOVE_STUDENT_WORK.SUCCESS,
	REMOVE_STUDENT_WORK.ERROR,
	Correction,
	{ correctionId: string }
>;

export type CorrectionsActionTypes =
	| CreateCorrectionAction
	| GetCorrectionAction
	| UpdateCorrectionAction
	| AddStudentWorkAction
	| RemoveStudentWorkAction;
